export const EMMA_DOMAIN_REGEX = /(dev-|sit-|uat-|preprod-)?emma\.axa\.com\.hk/;
